// eslint-disable-next-line no-unused-vars
export default theme => ({
  dialog: {},
  tableCell: {
    whiteSpace: 'nowrap',
  },
  tableCellInner: {
    display: 'flex',
    alignItems: 'center'
  },
  alignLeft: {
    align: 'left',
  },
  dangerColor: {
    color: theme.palette.danger.main
  }
});
